module.exports = __webpack_public_path__ + "sb.svg?c8e9b05ffbde6543934005ea21851055";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/sb.svg
// module id = 1369
// module chunks = 27